module.exports = __webpack_public_path__ + "assets/media/autumn-day.b960c1bf.ogg";